import React from "react";
import SearchDropdown from "../../../../components/UI/PageInput/SearchDropdown";
import CustomInput from "../../../../components/UI/PageInput/CustomInput";

const BankInfo = ({
  userSetup,
  register,
  errors,
  setValue,
  control,
  bankNameId,
}) => {
  return (
    <div className="halfCol pl-1">
      <div className="userInfoWrap">
        <h4 className="userInfoHeading">Bank Info</h4>
        <div className="px-4 py-6">
          <SearchDropdown
            name="bankNameId"
            label="Bank Name"
            keyName="name"
            id="id"
            options={userSetup.banks}
            control={control}
            setValue={setValue}
            error={errors.bankNameId}
            search={true}
            selectedVal={bankNameId}
            disableValidationMessage={true}
          />
          <CustomInput
            type="text"
            name="ifsc"
            labelText="IFSC Code"
            placeholder="Enter"
            register={{
              ...register("ifsc", { required: "Please Enter IFSC" }),
            }}
            error={errors.ifsc}
          />
          <CustomInput
            type="number"
            name="accountNumber"
            labelText="Bank Account No."
            placeholder="Enter"
            register={{
              ...register("accountNumber", {
                required: "Please Enter Account Number",
                min: {
                  value: 1,
                  message: "Account Number can't be 0",
                },
                pattern: {
                  value: /^\d+$/,
                  message: "Only numbers are allowed",
                },
              }),
            }}
            error={errors.accountNumber}
          />
          <CustomInput
            type="text"
            name="branchName"
            labelText="Bank Branch"
            placeholder="Enter"
            register={{
              ...register("branchName", {
                required: "Please Enter a Branch Name",
              }),
            }}
            error={errors.branchName}
          />
        </div>
      </div>
    </div>
  );
};

export default BankInfo;
